export default "__VITE_ASSET__D34LFl8K__"